import * as React from 'react';

import type {EntityListType} from 'nutshell-core/types';

import {Link} from 'shells/link/link';

// @ts-expect-error
import {mapEntityType} from '../../../entities/helpers';

import {CreateFormOpenButton} from '../../creator/create-form-open-button';

const heightOfRow = 55;
const heightOfEmptySection = 225;

type Props = {
    type: EntityListType;
    unfilteredCount: number;
    tableHeight: number;
};

export class TableEmptyView extends React.Component<Props> {
    render() {
        const {type, unfilteredCount, tableHeight} = this.props;
        const shouldShowTable =
            tableHeight - unfilteredCount * heightOfRow > 350 || unfilteredCount === 0;

        const bottom = (tableHeight - unfilteredCount * heightOfRow) / 2 - heightOfEmptySection / 2;

        return shouldShowTable ? (
            <div
                className={`ui-entity-list__empty-state ui-entity-list__empty-state--type-${type}`}
                style={{bottom: bottom}}
            >
                <img
                    src={`/include/images/entity-lists/empty-state/${mapEntityType(
                        type,
                        true
                    )}_2x.png`}
                />
                <p>{this.renderEntityText(type)}</p>
                <div className='ui-entity-list__empty-state__action-btns'>
                    <CreateFormOpenButton type={this.props.type} />
                    <Link variant='button-primary' size='big' href='/setup/import'>
                        {this.renderEntityEmptyText(type)}
                    </Link>
                </div>
            </div>
        ) : (
            <div />
        );
    }

    renderEntityText(type: EntityListType) {
        if (type === 'contacts') {
            return 'Keep track of everyone you do business with';
        } else if (type === 'accounts' || type === 'mcfxcompanies') {
            return 'Keep track of the companies you work with';
        } else {
            return 'Keep track of new opportunities and customers';
        }
    }

    renderEntityEmptyText(type: EntityListType) {
        if (type === 'contacts' || type === 'accounts' || type === 'mcfxcompanies') {
            return 'Import your contacts';
        } else {
            return 'Import your leads';
        }
    }
}
